function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0207 18.1V20H7.97927V18.2L7.11572 17.9C6.14853 17.5667 5.25043 17.0667 4.45596 16.4L3.76511 15.8333L2.038 16.8L0 13.4333L1.76166 12.4333L1.62349 11.5667C1.51986 11.0667 1.48532 10.6 1.48532 10.1333C1.48532 9.6 1.5544 9.06667 1.65803 8.53333L1.83074 7.66667L0 6.63333L2.038 3.26667L3.90328 4.33333L4.59413 3.76667C5.35406 3.16667 6.21762 2.73333 7.11572 2.4L7.97927 2.1V0H11.9862V2.1L12.8497 2.4C13.7824 2.7 14.6114 3.16667 15.3713 3.76667L16.0622 4.33333L17.962 3.26667L20 6.63333L18.1693 7.66667L18.342 8.43333C18.4456 8.96667 18.5147 9.5 18.5147 10.0333C18.5147 10.5 18.4801 11 18.3765 11.4667L18.2383 12.3333L20 13.3333L17.962 16.7L16.2349 15.7333L15.544 16.3C14.7496 16.9667 13.8515 17.4667 12.8843 17.8L12.0207 18.1ZM10 6C7.82178 6 6 7.78218 6 10C6 12.1782 7.78218 14 10 14C12.1782 14 14 12.2178 14 10C13.9604 7.78218 12.1782 6 10 6Z",
  fill: "currentColor"
});

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c3f2f01d.svg";
export { ForwardRef as ReactComponent };